export const expirationMixin = {
  data () {
    return {
      headers: [
        { text: 'Estado', value: 'status', filterField: true, sortable: false },
        { text: 'Vencimiento', value: 'date', sortable: false },
        { text: 'Criterio', value: 'criterion', sortable: false },
        { text: 'Subárea', value: 'subarea', sortable: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ],
      properties: ['statusDisplay', 'date', 'criterion', 'subarea'],
      defaults: { 'date': 'Sin asignar' },
      path: 'vencimientos',
      filterPath: 'filters/vencimientos'
    }
  }
}
